import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'enumToArray',
    standalone: true,
    pure: true,
})
export class EnumToArrayPipe implements PipeTransform {

  transform(value: object): any {
    return Object.keys(value);
  }

}
